import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap';
import './assets/app.scss';
import 'grapp/dist/grapp.css';

const VueCookie = require('vue-cookie');

Vue.use(Vuelidate);
Vue.use(VueCookie);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render(h) { return h(App); },
}).$mount('#app');
